import React from 'react';

// =============================================================================
// PerformanceCardSkeleton — shape-of-card placeholder for Performance
// sections (Summary / Display / Transactions V2 / BasketItems V2 / SignUps
// V2 / Sessions V2 / etc.). Mirrors the `.campaign-overview__performance`
// shell — eyebrow + 4-column KPI row + chart area — using the generic
// `.skeleton` shimmer primitive from `_design-system.scss` §20.
//
// Consumed by every non-Overview tab's tab-level loading state. See
// SPECIFICATION §10 consumer contract for the "shimmer-per-card" loading
// pattern.
// =============================================================================

const KPI_COUNT = 4;

const bar = (width, height = 16, radius = 4) => (
  <span
    className="skeleton"
    style={{
      width,
      height,
      borderRadius: radius,
      display: 'inline-block',
    }}
  />
);

const PerformanceCardSkeleton = () => (
  <section className="campaign-overview__performance">
    <header className="campaign-overview__performance-head">
      {bar(96, 12, 4)}
    </header>

    <div className="campaign-details-skeleton__kpi-row">
      {Array.from({ length: KPI_COUNT }).map((_, i) => (
        <div key={i} className="campaign-details-skeleton__kpi">
          {bar(32, 32, 8)}
          {bar(90, 12, 4)}
          {bar(140, 28, 6)}
        </div>
      ))}
    </div>

    <div style={{ padding: 16 }}>
      {bar('100%', 280, 12)}
    </div>
  </section>
);

export default PerformanceCardSkeleton;
